<template>
  <section v-if="visible" class="flex justify-center">
    <LcButton
      class="px-300"
      data-testid="editor-delete-all-plays-button"
      icon="trash-full"
      size="medium"
      variant="filled"
      @click="openDeleteAllPlaysModal"
    >
      {{ $t('lottery.selectednumbersactions.button.deletealllines') }}
    </LcButton>
  </section>
</template>

<script lang="ts" setup>
import EditorDeleteAllPlaysModal from './DeleteAllPlaysModal.vue'

type Emits = {
  (e: 'confirm'): void
}

type Props = {
  visible: boolean
}

const emit = defineEmits<Emits>()

defineProps<Props>()

const { openModal } = useModal()

const openDeleteAllPlaysModal = () =>
  openModal({
    component: EditorDeleteAllPlaysModal,
    id: 'editor-delete-all-plays',
    onConfirm: () => emit('confirm'),
    stack: true,
  })
</script>
